import React, { useEffect, useState } from "react";
import PagesIndex from "../../business/PagesIndex";
import Index from "../../business/Index";
import "./Home.css";
import "./Home.responsive.css";
import GetInContact from "./GetInContact";

const BusinessHome = () => {
  return (
    <>
      <PagesIndex.UserHeader />

      <Index.Box className="bg-user-landing business-home-bg">
        <Index.Box className="container-user">
          <Index.Box className="hero-grid-user">
            <Index.Box className="hero-left-cols">
              <Index.Box className="hero-welcome-details">
                <Index.Box className="hero-welcome-content">
                  <span></span>
                  <Index.Typography
                    component="h6"
                    className="welcome-ugoout-title"
                  >
                    Welcome to UGO OUT Partners
                  </Index.Typography>
                </Index.Box>
                <Index.Box className="key-offer-contain">
                  <Index.Typography className="heading-key">
                    We’re redefining local shopping by making it easier and more
                    rewarding to support high street businesses
                  </Index.Typography>
                  <Index.Typography className="description-key">
                    Our platform bridges the gap between consumers and local
                    businesses with a simple yet powerful platform: free taxi
                    rides in exchange for minimum spends. We make physical
                    shopping more convenient, fun, and impactful—supporting
                    local businesses and giving users a better deal.
                  </Index.Typography>
                </Index.Box>
              </Index.Box>
            </Index.Box>
            <Index.Box className="hero-right-cols">
              <Index.Box className="hero-ugo-bg position-relative">
                <img
                  src={PagesIndex.Png.ugovector}
                  alt="ugovector"
                  className="ugovector-img"
                />
              </Index.Box>
            </Index.Box>
          </Index.Box>
        </Index.Box>
      </Index.Box>

      {/* Booking ride section start */}

      <Index.Box className="booking-ride-main business-booking-main">
        <Index.Box className="container-user">
          <Index.Box className="booking-ride">
            <Index.Box className="grid-booking-ride">
              <Index.Box className="left-booking-ride">
                <Index.Box className="booking-ride-content">
                  <Index.Box className="booking-content">
                    <span></span>
                    <Index.Typography
                      component="h6"
                      className="welcome-booking-title"
                    >
                      Our Mission & Vision
                    </Index.Typography>
                  </Index.Box>
                  <Index.Box className="key-booking-contain">
                    <Index.Box className="booking-ride-details">
                      <Index.List className="booking-ride-list">
                        <Index.ListItem className="booking-ride-list-item">
                          <Index.Typography className="ride-title-book">
                            Our Mission
                          </Index.Typography>
                          <Index.Typography className="ride-title-desc">
                            To empower local businesses and enhance community
                            engagement by providing customers with seamless,
                            incentivized access to the high street
                          </Index.Typography>
                        </Index.ListItem>
                        <Index.ListItem className="booking-ride-list-item">
                          <Index.Typography className="ride-title-book">
                            Our Vision
                          </Index.Typography>
                          <Index.Typography className="ride-title-desc">
                            We envision vibrant towns and cities where local
                            businesses thrive, foot traffic flourishes, and
                            communities reconnect—fuelled by innovative,
                            accessible transport solutions.
                          </Index.Typography>
                        </Index.ListItem>
                      </Index.List>
                    </Index.Box>
                  </Index.Box>
                </Index.Box>
                <Index.Box className="booking-ride-content">
                  <Index.Box className="booking-content">
                    <span></span>
                    <Index.Typography
                      component="h6"
                      className="welcome-booking-title"
                    >
                      Why partner with us
                    </Index.Typography>
                  </Index.Box>
                  <Index.Box className="key-booking-contain">
                    <Index.Box className="booking-ride-details">
                      <Index.List className="booking-ride-list">
                        <Index.ListItem className="booking-ride-list-item">
                          <Index.Typography className="ride-title-book">
                            Taking you business further
                          </Index.Typography>
                          <Index.Typography className="ride-title-desc">
                            Partnering with UgoOut means instant exposure to
                            local customer.
                          </Index.Typography>
                        </Index.ListItem>
                        <Index.ListItem className="booking-ride-list-item">
                          <Index.Typography className="ride-title-book">
                            The Future of marking
                          </Index.Typography>
                          <Index.Typography className="ride-title-desc">
                            UgoOut is dedicated to driving real customers to
                            your door—not just boosting your online presence or
                            relying on costly digital ads. Our goal is to
                            deliver genuine value to your business through our
                            platform
                          </Index.Typography>
                        </Index.ListItem>
                      </Index.List>
                    </Index.Box>
                  </Index.Box>
                </Index.Box>
              </Index.Box>
              <Index.Box className="right-booking-ride">
                <Index.Box className="booking-ride-img position-relative">
                  <Index.Box className="booking-bg-overlay">
                    <img
                      src={PagesIndex.Png.businessbg}
                      alt="ride"
                      className="ride-img"
                    />
                  </Index.Box>
                </Index.Box>
              </Index.Box>
            </Index.Box>
          </Index.Box>
        </Index.Box>
      </Index.Box>

      {/* get in contact section start */}
      <GetInContact />

      {/* footer section start */}

      <Index.Box className="footer-details">
        <PagesIndex.UserFooter />
      </Index.Box>
    </>
  );
};

export default BusinessHome;
